const ApiStrings = {
  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  ME: "/auth/me",
  STATS: "/auth/stats",
  USER_DETAILS: (username: string) => `/auth/${username}/details`,
  PRIVACY_SETTING: "/auth/privacy-settings",
  NOTIFICATION_PREFERENCE: "/auth/notification-preference",
  CHANGE_PASSWORD: "/auth/change-password",
  ENABLE_2FA: "/auth/2fa/enable",
  VERIFY_2FA: "/auth/2fa/verify",
  DISABLE_2FA: "/auth/2fa/disable",
  RECOVER_LOGIN: "/auth/recover-login",
  REQUEST_OTP: "/auth/request-otp",
  DELETE_ACCOUNT: "/auth/account-delete",
  CANCEL_ACCOUNT_DELETE: "/auth/cancel-deletion",
  DISCOVER_PEOPLE: "/auth/discover-people",
  EMAIL_VERIFY_2FA: "/auth/2fa/email-verify",
  RESEND_EMAIL: "/auth/resend",
  FORGOT_PASSWORD: "/auth/forgot-password",
  RESET_PASSWORD: "/auth/reset-password",
  VERIFY_STEP1: "/auth/verify-step1",
  VERIFY_STEP2: "/auth/verify-step2",
  VERIFY_STEP3: "/auth/verify-step3",
  STATUS: "/auth/status",
  BLOCK: "/auth/block",
  GET_BLOCK_USERS: "/auth/blocked-users",
  UNBLOCK: "/auth/unblock",
  CHECK_MIN_REQUIREMENT: "/auth/check-minium-requirement",
  // Sessions
  GET_SESSIONS: "/session/",
  LOGOUT: "/session/logout",

  // Posts
  ALL_POSTS: "/post/",
  BOOKMARK_POSTS: "/post/bookmark/posts",
  FOLLOWING_ALL_POSTS: "/post/following/posts",
  EDITPOST: (id: number) => `/post/edit/${id}`,
  DELETEPOST: (id: number) => `/post/delete/${id}`,
  DELETE_MEDIA: (id: number) => `/post/delete/media/${id}`,
  REACTPOST: (id: number) => `/post/react/${id}`,
  SHAREPOST: (id: number) => `/post/share/${id}`,
  BOOKMARK_POST: (id: number) => `/post/bookmark/${id}`,
  USER_SUGGESTION: `/post/suggest`,
  MY_POST: `/post/my-post`,
  DELETE_POSTS: `/post/delete/all`,
  // comments
  CREATE_COMMENT: (id: number) => `/comment/${id}`,
  EDIT_COMMENT: (id: number) => `/comment/edit/${id}`,
  REPLY_COMMENT: (id: number) => `/comment/reply/${id}`,
  DELETE_COMMENT: (id: number) => `/comment/delete/${id}`,
  COMMENT_REACT: (id: number) => `/comment/react/${id}`,
  GET_COMMENTS: (id: number) => `/comment/${id}/comments`,
  // Follow
  FOLLOW_UNFOLLOW: (id: number) => `/follow/${id}`,
  CREATE_STORY: `/follow/story/create`,
  DELETE_STORY: `/follow/story`,
  GET_STORIES: `/follow/stories`,
  // Conversation
  GET_CONVERSATION: `/conversation/`,
  ARCHIVE_CONVERSATIONS: `/conversation/archive-chat`,
  GET_CONVERSATION_MESSAGE: (id?: number) => `/conversation/${id}`,
  SEND_MESSAGE: `/conversation/send-message`,
  ARCHIVE_CHAT: `/conversation/archive-chat`,
  UNARCHIVE_CHAT: `/conversation/unarchive-chat`,
  CREATE_CONVERSATION: `/conversation/create`,
  READ_MESSAGE: `/conversation/read-message`,
  SEND_ATTACHMENT: `/conversation/send-attachment`,
  DELETE_CONVERSATION: `/conversation/delete`,
  REACT_MESSAGE: `/conversation/react`,
  EDIT_MESSAGE: `/conversation/edit`,
  DELETE_MESSAGE: `/conversation/message/delete`,
  UNDO_DELETE_MESSAGE: `/conversation/message/undo`,
  REPLY_MESSAGE: `/conversation/reply`,
  // stream
  INITIAL_CALL: "/stream/initiate-call",
  GET_LIVES: "/stream/",
  START_LIVE: "/stream/start",
  END_LIVE: "/stream/end",
  GET_CHATS: "/stream/chats",
  SEND_CHAT: "/stream/chat",
  GET_SHORTS: "/stream/shorts",
  UPLOAD_SHORT: "/stream/upload-short",
  DELETE_SHORT: "/stream/short",
  DELETE_STREAM: "/stream/short",
  REACT_SHORT: "/stream/short",
  MY_SHORTS: "/stream/my-shorts",
  MY_LIVES: "/stream/my-lives",
  SHORTS_DELETE: "/stream/shorts/delete/all",
  // report
  REPORT: "/report/",
  BAN_USER: (id: number) => `/report/ban/${id}`,
  // Notification
  GET_ALL_NOTIFICATION: "/notification",
  MARK_READ_NOTIFICATION: "/notification/mark-read",
};

export default ApiStrings;
